// extracted by mini-css-extract-plugin
export var csatScore = "_lr-5";
export var header = "_lr-1";
export var panelWrapper = "_lr-2";
export var postPreview = "_lr-3";
export var rightContent = "_lr-0";
export var wrappingText = "_lr-4";